import { cn } from '#app/utils/misc.js'

interface TraitBadgeProps {
	trait: string
	type: 'positive' | 'negative'
}

export function TraitBadge({ trait, type }: TraitBadgeProps) {
	const isPositive = type === 'positive'
	const baseClasses =
		'group relative overflow-hidden rounded-md px-3 py-1 text-sm font-medium transition-all duration-300 ease-in-out'
	const colorClasses = isPositive
		? 'bg-green-100 text-green-800 hover:bg-green-200 dark:bg-green-900 dark:text-green-100 dark:hover:bg-green-800'
		: 'bg-red-100 text-red-800 hover:bg-red-200 dark:bg-red-900 dark:text-red-100 dark:hover:bg-red-800'
	const gradientClasses = isPositive
		? 'bg-gradient-to-r from-green-400 to-green-500 dark:from-green-600 dark:to-green-700'
		: 'bg-gradient-to-r from-red-400 to-red-500 dark:from-red-600 dark:to-red-700'

	return (
		<div className={cn(baseClasses, colorClasses)}>
			<span className="relative z-10">
				{trait.trim().charAt(0).toUpperCase() + trait.trim().slice(1)}
			</span>
			<span
				className={cn(
					'absolute inset-0 z-0 opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100',
					gradientClasses,
				)}
			></span>
		</div>
	)
}
